import { createAPI } from '../../common'

export default {
  getPaperPathAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0qbqfsqbui0bmm', 'get', config),
  putPaperPath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0qbqfsqbui', 'put', config)
}
